import { render, staticRenderFns } from "./Reorganizev2.vue?vue&type=template&id=b57409aa&"
import script from "./Reorganizev2.vue?vue&type=script&lang=js&"
export * from "./Reorganizev2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports